module.exports = __webpack_public_path__ + "img/00-menu-bar-off_03.5b49f3e7.png";